const removeDuplicatesFromArray = (arr) =>
  arr.reduce((acc, obj) => {
    if (!acc.map(({ id }) => id).includes(obj.id)) {
      acc.push(obj);
    }
    return acc;
  }, []);

export default removeDuplicatesFromArray;
